import React, { useState } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { Container, ContentWithPaddingXl } from "components/misc/Layouts.js";
import { SectionHeading } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg-decorator-blob-7.svg";

import postitImgSrc from "images/postit.jpg"
import cintaImgSrc from "images/cinta.jpg"
import perforadorImgSrc from "images/perforadora.jpg"
import abacoImgSrc from "images/abaco.jpg"
import dispensadorImgSrc from "images/dispensador.jpg"
import archivadorImgSrc from "images/archivador.jpg"
import almohadillaImgSrc from "images/almoadilla.jpg"
import pizarronImgSrc from "images/pizarra.jpg"

import codigoCivilImgSrc from "images/codigo-civil.jpeg"
import codigoPenalImgSrc from "images/codigo.procesal-penal.jpeg"
import constitucionImgSrc from "images/constitucion.jpeg"
import comercioImgSrc from "images/codigo-comercio.jpeg"
import trabajoImgSrc from "images/codigo-trabajo.jpeg"
import ivaImgSrc from "images/iva.jpeg"
import judicialImgSrc from "images/judicial.jpeg"
import tributariaImgSrc from "images/tributaria.jpeg"

import reImgSrc1 from "images/re1.jpeg"
import reImgSrc2 from "images/re2.jpeg"
import reImgSrc3 from "images/re3.jpeg"
import reImgSrc4 from "images/re4.jpeg"
import reImgSrc5 from "images/re5.jpeg"
import reImgSrc6 from "images/re6.jpeg"
import reImgSrc7 from "images/re7.jpeg"
import reImgSrc8 from "images/re8.jpeg"
import reImgSrc9 from "images/re9.jpeg"
import reImgSrc10 from "images/re10.jpeg"
import reImgSrc11 from "images/re11.jpeg"
import reImgSrc12 from "images/re12.jpeg"
import reImgSrc13 from "images/re13.jpeg"
import reImgSrc14 from "images/re14.jpeg"
import reImgSrc15 from "images/re15.jpeg"
import reImgSrc16 from "images/re16.jpeg"
import reImgSrc17 from "images/re17.jpeg"
import reImgSrc18 from "images/re18.jpeg"
import reImgSrc19 from "images/re19.jpeg"

import manuaImgSrc1 from "images/manua1.jpeg"
import manuaImgSrc2 from "images/manua2.jpeg"
import manuaImgSrc3 from "images/manua3.jpeg"
import manuaImgSrc4 from "images/manua4.JPG"
import manuaImgSrc5 from "images/manua5.jpeg"
import manuaImgSrc6 from "images/manua6.jpeg"
import manuaImgSrc7 from "images/manua7.jpeg"

const HeaderRow = tw.div`flex justify-between items-center flex-col xl:flex-row`;
const Header = tw(SectionHeading)``;
const TabsControl = tw.div`flex flex-wrap bg-gray-200 px-2 py-2 rounded leading-none mt-12 xl:mt-0`;

const TabControl = styled.div`
  ${tw`cursor-pointer px-6 py-3 mt-2 sm:mt-0 sm:mr-2 last:mr-0 text-gray-600 font-medium rounded-sm transition duration-300 text-sm sm:text-base w-1/2 sm:w-auto text-center`}
  &:hover {
    ${tw`bg-gray-300 text-gray-700`}
  }
  ${props => props.active && tw`bg-[#1DA1F2]! text-gray-100!`}
  }
`;

const TabContent = tw(motion.div)`mt-6 flex flex-wrap sm:-mr-10 md:-mr-6 lg:-mr-12`;
const CardContainer = tw.div`mt-10 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 sm:pr-10 md:pr-6 lg:pr-12`;
const Card = tw(motion.a)`bg-gray-200 rounded-b block max-w-xs mx-auto sm:max-w-none sm:mx-0`;
const CardImageContainer = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-56 xl:h-64 bg-center bg-cover relative rounded-t`}
`;
//const CardRatingContainer = tw.div`leading-none absolute inline-flex bg-gray-100 bottom-0 left-0 ml-4 mb-4 rounded-full px-5 py-2 items-end`;
/*const CardRating = styled.div`
  ${tw`mr-1 text-sm font-bold flex items-end`}
  svg {
    ${tw`w-4 h-4 fill-current text-orange-400 mr-1`}
  }
`;*/

const CardHoverOverlay = styled(motion.div)`
  background-color: rgba(255, 255, 255, 0.5);
  ${tw`absolute inset-0 flex justify-center items-center`}
`;
const CardButton = tw(PrimaryButtonBase)`text-sm`;

//const CardReview = tw.div`font-medium text-xs text-gray-600`;

const CardText = tw.div`p-4 text-gray-900`;
const CardTitle = tw.h5`text-lg font-semibold group-hover:text-primary-500`;
const CardContent = tw.p`mt-1 text-sm font-medium text-gray-600`;
//const CardPrice = tw.p`mt-4 text-xl font-bold`;

const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-pink-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-primary-500`}
`;

export default ({
  heading = "Checkout the Menu",
  tabs = {
    "Escolar y Oficina": [
      {
        imageSrc:postitImgSrc,
        title: "BLOCK POST IT",
        content: "BLOCK POST IT ADHES. 3M 3X3",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: cintaImgSrc,
        title: "CINTA DE EMPAQUE",
        content: "CINTA DE EMPAQUE TESA 1000 X 48",
        price: "$2.99",
        rating: "4.8",
        reviews: "32",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: perforadorImgSrc,
        title: "PERFORADOR",
        content: "PERFORADOR SINA FINA",
        price: "$7.99",
        rating: "4.9",
        reviews: "89",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: abacoImgSrc,
        title: "ABACO",
        content: "ABACO",
        price: "$8.99",
        rating: "4.6",
        reviews: "12",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: dispensadorImgSrc,
        title: "DISPENSADOR",
        content: "DISPENSADOR CINTA",
        price: "$7.99",
        rating: "4.2",
        reviews: "19",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: archivadorImgSrc,
        title: "ARCHIVADOR",
        content: "ARCHIVADOR ACORDEON",
        price: "$2.99",
        rating: "5.0",
        reviews: "61",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: almohadillaImgSrc,
        title: "ALMOHADILLA",
        content: "ALMOHADILLA PARA PIZARRON",
        price: "$3.99",
        rating: "4.2",
        reviews: "95",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: pizarronImgSrc,
        title: "PIZARRON DE FORMICA",
        content: "PIZARRON DE FORMICA PARA OFICINA",
        price: "$3.99",
        rating: "3.9",
        reviews: "26",
        url: "https://wa.me/50235991860"
      }
    ],
    Manualidades: [
      {
        imageSrc:manuaImgSrc1,
        title: "TIJERAS",
        content: "TIJERAS CON FORMAS",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: manuaImgSrc2,
        title: "LISTON",
        content: "LISTONES DE COLORES PARA MANUALIDADES",
        price: "$2.99",
        rating: "4.8",
        reviews: "32",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: manuaImgSrc3,
        title: "CINTA",
        content: "CINTA DE COLORES",
        price: "$7.99",
        rating: "4.9",
        reviews: "89",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: manuaImgSrc4,
        title: "ARTICULOS VARIOS",
        content: "ARTICULOS VARIOS PARA MANUALIDADES",
        price: "$8.99",
        rating: "4.6",
        reviews: "12",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: manuaImgSrc5,
        title: "PAPEL ARCOIRIS",
        content: "PAPEL ARCOIRIS DE COLORES",
        price: "$7.99",
        rating: "4.2",
        reviews: "19",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: manuaImgSrc6,
        title: "HOJAS DE FIELTRO",
        content: "HOJAS DE FIELTRO DE COLORES",
        price: "$2.99",
        rating: "5.0",
        reviews: "61",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: manuaImgSrc7,
        title: "HOJAS FOMI",
        content: "HOJAS FOMIS DE COLORES CON TEXTURA",
        price: "$3.99",
        rating: "4.2",
        reviews: "95",
        url: "https://wa.me/50235991860"
      }
    ],
    Leyes: [
      {
        imageSrc:constitucionImgSrc,
        title: "CONSTITUCION DE LA REPUBLICA",
        content: "CONSTITUCION POLITICA",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: trabajoImgSrc,
        title: "CODIGO DE TRABAJO",
        content: "CODIGO DE TRABAJO DE GUATEMALA",
        price: "$2.99",
        rating: "4.8",
        reviews: "32",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: codigoPenalImgSrc,
        title: "CODIGO PENAL",
        content: "CODIGO PROCESAL PENAL",
        price: "$7.99",
        rating: "4.9",
        reviews: "89",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: codigoCivilImgSrc,
        title: "CODIGO CIVIL",
        content: "CODIGO CIVIL DE GUATEMALA",
        price: "$8.99",
        rating: "4.6",
        reviews: "12",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc: comercioImgSrc,
        title: "CODIGO DEL COMERCIO",
        content: "CODIGO DEL COMERCIO DE GUATEMALA",
        price: "$7.99",
        rating: "4.2",
        reviews: "19",
        url: "https://wa.me/50235991860"
      },{
        imageSrc: ivaImgSrc,
        title: "LEY DE IVA",
        content: "LE DE IMPUESTO AL VALOR AGREGADO (IVA)",
        price: "$7.99",
        rating: "4.2",
        reviews: "19",
        url: "https://wa.me/50235991860"
      },{
        imageSrc: judicialImgSrc,
        title: "LEY DEL ORGANISMO JUDICIAL",
        content: "LEY DEL ORGANISMO JUDICIAL",
        price: "$7.99",
        rating: "4.2",
        reviews: "19",
        url: "https://wa.me/50235991860"
      },{
        imageSrc: tributariaImgSrc,
        title: "LEY DE ACTUALIZACION TRIBUTARIA",
        content: "LEY DE ACTUALIZACION TRIBUTARIA",
        price: "$7.99",
        rating: "4.2",
        reviews: "19",
        url: "https://wa.me/50235991860"
      }

    ],
    Regalos: [
      {
        imageSrc:reImgSrc1,
        title: "CINTURON DE CURO",
        content: "CINTURON DE CUERO DIVERSOS COLORES",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc2,
        title: "BOLSA ESTILO CANGURERA",
        content: "BOLSA ESTILO CANGURERA",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc3,
        title: "BILLETERAS DE CUERO",
        content: "BILLETERAS DE CUERO DIVERSOS COLORES",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc4,
        title: "RELOJES DE CABALLERO",
        content: "RELOJES DE CABALLEROS EN DIVERSOS COLORES",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc5,
        title: "LINTERNA PORTATIL",
        content: "LINTERNA PORTATIL",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc6,
        title: "BEBE DE JUGUETE",
        content: "BEBE DE JUGUTE PARA NIÑA",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc7,
        title: "BARBIE",
        content: "BARBIE PARA NIÑA",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc8,
        title: "MINI SET DE COCINA",
        content: "MINI SET DE COCINA DE PLASTICO",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc9,
        title: "SET DE UTENCILIOS DE COCINA",
        content: "SET DE UTENCILIOS DE COCINA",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc10,
        title: "BARBIE VERSION SIRENA",
        content: "BARBIE VERSION SIRENA",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc11,
        title: "TREN DE JUGUETE",
        content: "TREN DE JUGUETE PARA NIÑO",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc12,
        title: "JUEGO DE CARROS",
        content: "JUEGO DE CARROS PARA NIÑO",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc13,
        title: "KIT DE HERRAMIENTAS DE CONSTRUCCION",
        content: "KIT DE HERRAMIENTAS DE CONSTRUCCION",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc14,
        title: "ESCABADORA MULTIFUNCIONAL",
        content: "ESCABADORA MULTIFUNCIONAL",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc15,
        title: "TREN INTERACTIVO",
        content: "TREN INTERACTIVO PARA NIÑO",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc16,
        title: "MONEDEROS",
        content: "MONEDEROS DAMA DIVERSOS COLORES",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc17,
        title: "RELOJ PARA DAMA",
        content: "RELOJ PARA DAMA DIVERSOS ESTILOS Y COLORES",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc18,
        title: "GANCHOS Y MOÑOS",
        content: "GANCHOS Y MOÑOS PARA DAMA Y NIÑA",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      },
      {
        imageSrc:reImgSrc19,
        title: "MONEDEROS DE MANO",
        content: "MONEDEROS PARA DAMA Y NIÑA",
        price: "$5.99",
        rating: "5.0",
        reviews: "87",
        url: "https://wa.me/50235991860"
      }
      
    ]
  }
}) => {
  /*
   * To customize the tabs, pass in data using the `tabs` prop. It should be an object which contains the name of the tab
   * as the key and value of the key will be its content (as an array of objects).
   * To see what attributes are configurable of each object inside this array see the example above for "Starters".
   */
  const tabsKeys = Object.keys(tabs);
  const [activeTab, setActiveTab] = useState(tabsKeys[0]);

  return (
    <Container>
      <ContentWithPaddingXl>
        <HeaderRow>
          <Header>{heading}</Header>
          <TabsControl>
            {Object.keys(tabs).map((tabName, index) => (
              <TabControl key={index} active={activeTab === tabName} onClick={() => setActiveTab(tabName)}>
                {tabName}
              </TabControl>
            ))}
          </TabsControl>
        </HeaderRow>

        {tabsKeys.map((tabKey, index) => (
          <TabContent
            key={index}
            variants={{
              current: {
                opacity: 1,
                scale:1,
                display: "flex",
              },
              hidden: {
                opacity: 0,
                scale:0.8,
                display: "none",
              }
            }}
            transition={{ duration: 0.4 }}
            initial={activeTab === tabKey ? "current" : "hidden"}
            animate={activeTab === tabKey ? "current" : "hidden"}
          >
            {tabs[tabKey].map((card, index) => (
              <CardContainer key={index}>
                <Card className="group" href={card.url} initial="rest" whileHover="hover" animate="rest">
                  <CardImageContainer imageSrc={card.imageSrc}>
                    {/*<CardRatingContainer>
                      <CardRating>
                        <StarIcon />
                        {card.rating}
                      </CardRating>
                      <CardReview>({card.reviews})</CardReview>
                    </CardRatingContainer>*/}
                    <CardHoverOverlay
                      variants={{
                        hover: {
                          opacity: 1,
                          height: "auto"
                        },
                        rest: {
                          opacity: 0,
                          height: 0
                        }
                      }}
                      transition={{ duration: 0.3 }}
                    >
                      <CardButton>Comprar Ahora</CardButton>
                    </CardHoverOverlay>
                  </CardImageContainer>
                  <CardText>
                    <CardTitle>{card.title}</CardTitle>
                    <CardContent>{card.content}</CardContent>
                    {/*<CardPrice>{card.price}</CardPrice>*/}
                  </CardText>
                </Card>
              </CardContainer>
            ))}
          </TabContent>
        ))}
      </ContentWithPaddingXl>
      <DecoratorBlob1 />
      <DecoratorBlob2 />
    </Container>
  );
};
